

import React from 'react'
import { Routes, Route, Navigate } from  'react-router-dom';
import Home from '../pages/Home'
import Contact from '../pages/Contact'
import Libros from '../pages/Libros'
import Gallery from '../pages/Gallery'

const Routers = () => {
return (
    <Routes>
        <Route path='/' element={<Navigate to="/home" />} />
        <Route path='/home' element={<Home />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/libros' element={<Libros />} />
        <Route path='/gallery' element={<Gallery />} />
    </Routes>
);
};

export default Routers